import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

export const JOB_SEARCH_FIELDS = [
  'title',
  'company.name',
  'location',
  'description.text',
  'mandatoryTechSkills',
  'desiredTechSkills',
  'optionalTechSkills',
  'languageRequirementsOther',
  'additionalRequirements.text',
  'practicalExperience.text',
  'employmentType',
];

export const createJobSearchFilter = (search = '', filter?: AdornisFilter): AdornisFilter =>
  new AdornisFilter({
    ...filter?.toJSON(),
    search,
    searchFields: [...JOB_SEARCH_FIELDS],
  });
